import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface MemoRequest {
    idx: number;
    memo?: string;
}

export interface MemoResponse {
    statusCode: number;
    message: string;
}

export const usePutTrackingMemo = (
    successCallback?: (data: MemoResponse) => void,
): UseMutationResult<MemoResponse, Error, MemoRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<MemoResponse, Error, MemoRequest>({
        mutationFn: async (memoData: MemoRequest) => {
            const response = await axiosInstance.put(enum_api_uri.tracking_memo, memoData);
            return response.data;
        },
        onSuccess: data => {
            successCallback?.(data);
            queryClient.invalidateQueries({ queryKey: ["useGetTrackingDetail"] });
        },
    });
};
